import React, { useState } from 'react';
import { Recoil, useRecoilValue, useSetRecoilState } from '../../Recoil';
import './styles.scss';
import { useComponent } from '@naviair-utm/react-shared-components';
import { Menu, Typography, Row, Divider } from 'antd';
import { ELanguages } from '../../Recoil/States';

interface ILanguageItems {
	/**@example Dansk */
	name: string;
	/**@example da-DK */
	code: ELanguages;
}
export interface ILanguageDropdownProps {
	/**The title to display, e.g. Skift Sprog */
	title: string;
	className?: string;
	placement?: 'bottomLeft' | 'bottomCenter' | 'bottomRight' | 'topLeft' | 'topCenter' | 'topRight' | undefined;
	/**Overwrite default languages. @default 'en-US', 'da-DK', 'kl-GL' */
	languageItems?: ILanguageItems[];
}

export const LanguageDropdown: React.FC<ILanguageDropdownProps> = ({
	title,
	className,
	placement,
	languageItems = [
		{ code: 'da-DK', name: 'Dansk' },
		{ code: 'en-US', name: 'English' },
		{ code: 'kl-GL', name: 'Kalaallisut' },
	],
}) => {
	const { DropDown } = useComponent();
	const setLanguage = useSetRecoilState(Recoil.Language.Selector);
	const [getSelectedKeys, setSelectedKeys] = useState([languageItems[0].code]);

	return (
		<DropDown
			icon={'globe-africa'}
			className={className}
			placement={placement}
			trigger={useRecoilValue(Recoil.DropDownTrigger.Selector)}
			overlay={
				<Menu className={'dropdownMenu'} selectedKeys={getSelectedKeys} onClick={({ key }) => setSelectedKeys([key as ELanguages])}>
					<Menu.ItemGroup
						title={
							<div className={'headerDiv'}>
								<Typography.Text className={'opacityText'}>{title}</Typography.Text>
							</div>
						}>
						<Menu.Divider />
						{languageItems.map((item) => {
							return (
								<Menu.Item key={item.code} onClick={() => setLanguage(item.code)}>
									<Row>
										<div className={'menuItemTitle'}>
											{item.code.substring(0, 2)}
											<Divider type={'vertical'} />
										</div>
										<div>{item.name}</div>
									</Row>
								</Menu.Item>
							);
						})}
					</Menu.ItemGroup>
				</Menu>
			}
		/>
	);
};
